import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "Market Shares on Category Best-Sellers", -1);
const _hoisted_4 = {
  class: "toolbar"
};
const _hoisted_5 = {
  class: "navigation-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_market_insights_filters = _resolveComponent("market-insights-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_performance_period_table = _resolveComponent("performance-period-table");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_performance_product_table = _resolveComponent("performance-product-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: "market-insights"
  }, _createSlots({
    topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_market_insights_filters)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])])])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["market-insights-contents", [_ctx.floatingTableState]])
    }, [_createVNode(_component_flex_column, {
      gap: 24,
      classes: "all-wrapper"
    }, {
      default: _withCtx(() => [_ctx.currentTabValue === 'default' ? (_openBlock(), _createBlock(_component_performance_period_table, {
        key: 0,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[5] || (_cache[5] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[3] || (_cache[3] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[4] || (_cache[4] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_performance_product_table, {
      loading: $data.productTableLoading,
      onRefreshOtherKpis: _cache[6] || (_cache[6] = $event => this.refreshMediator(['PERIOD_TABLE'])),
      onRefresh: _cache[7] || (_cache[7] = $event => $options.refreshProductTable()),
      onHandleSort: $options.handleProductTableSort,
      onChangeDate: $options.handleDateChange,
      onRestoreEvolutionTable: $options.restoreEvolutionTable
    }, null, 8, ["loading", "onHandleSort", "onChangeDate", "onRestoreEvolutionTable"])], 2)]),
    _: 2
  }, [_ctx.tabs.length > 1 ? {
    name: "topbar-sub",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_navigation_tabs, {
      tabs: _ctx.tabs,
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
    }, null, 8, ["tabs", "modelValue"]), _withDirectives(_createVNode(_component_period_controllers, {
      period: $options.period,
      "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.period = $event),
      periodCategory: $options.periodCategory,
      "onUpdate:periodCategory": _cache[2] || (_cache[2] = $event => $options.periodCategory = $event),
      periodOptions: $options.periodOptions,
      periodSelectorOptions: _ctx.periodSelectorOptions
    }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"]), [[_vShow, _ctx.floatingTableState === $data.FLOATING_COMPOUND_TABLE_STATES.FULL_SIZE]])])]),
    key: "0"
  } : undefined]), 1024);
}